import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID?.trim();
const dataset = process.env.REACT_APP_SANITY_DATASET?.trim() || 'production';
const token = (
  process.env.REACT_APP_SANITY_TOKEN
  || process.env.REACT_APP_SANITY_PROJECT_TOKEN
)?.trim();

const sanityConfig = {
  projectId,
  dataset,
  apiVersion: '2022-02-01',
  // CDN is for anonymous public reads only; with a token (private dataset) it often returns 403.
  useCdn: !token,
  ...(token ? { token } : {}),
};

const stubClient = {
  fetch: () => Promise.resolve([]),
  create: () => Promise.reject(
    new Error('Set REACT_APP_SANITY_PROJECT_ID (and REACT_APP_SANITY_TOKEN or REACT_APP_SANITY_PROJECT_TOKEN for private data / contact form)'),
  ),
  config: {},
};

export const client = projectId
  ? sanityClient(sanityConfig)
  : stubClient;

const builder = projectId ? imageUrlBuilder(client) : null;

export const urlFor = (source) => {
  if (!builder || !source) return '';
  return builder.image(source);
};
